import { render, staticRenderFns } from "./preferential_policies.vue?vue&type=template&id=26dd7af2&scoped=true&"
import script from "./preferential_policies.vue?vue&type=script&lang=js&"
export * from "./preferential_policies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dd7af2",
  null
  
)

export default component.exports